import { render, staticRenderFns } from "./GlobalBody.vue?vue&type=template&id=645afe5c&scoped=true&"
import script from "./GlobalBody.vue?vue&type=script&lang=ts&"
export * from "./GlobalBody.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalBody.vue?vue&type=style&index=0&id=645afe5c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645afe5c",
  null
  
)

export default component.exports